// Daisy Does site-wide config: brand strings, phone, sections, etc.
export const SITE = {
  brand: "Daisy Does",
  tagline: "Practical help, calmly done.",
  altTagline:
    "Admin, applications and everyday support for people who need an extra pair of hands.",
  founder: "Sarah",
  phone: "07771361508",
  phoneDisplay: "07771 361 508",
  tel: "tel:+447771361508",
  email: "hello@daisydoes.co.uk",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/benefit-application-help", label: "Benefit Help" },
  { to: "/elderly-support", label: "Elderly Support" },
  { to: "/about", label: "About Sarah" },
  { to: "/pricing", label: "Pricing" },
  { to: "/contact", label: "Contact" },
];

// Preferred homepage section order (from spec)
export const HOMEPAGE_SECTIONS = [
  "hero",
  "trust_strip",
  "guided_choice_section",
  "services_overview",
  "additional_services",
  "benefit_support",
  "booking_section",
  "about_sarah",
  "how_it_works",
  "why_choose_daisy_does",
  "testimonials",
  "pricing_preview",
  "contact_options_section",
  "final_cta",
  "contact_form",
];

export const SERVICES_PAGE_SECTIONS = [
  "services_hero",
  "service_cards",
  "additional_services",
  "household_admin",
  "benefit_support",
  "elderly_support_block",
  "family_support_block",
  "applications_forms_block",
  "home_services_block",
  "testimonials",
  "disclaimer",
  "booking_section",
  "final_cta",
  "contact_form",
];

export const BENEFIT_PAGE_SECTIONS = [
  "benefit_hero",
  "benefit_types",
  "how_sarah_helps",
  "testimonials",
  "documents_needed",
  "benefit_process",
  "disclaimer",
  "booking_section",
  "final_cta",
  "contact_form",
];

export const ELDERLY_PAGE_SECTIONS = [
  "elderly_hero",
  "trust_strip",
  "elderly_support_block",
  "benefit_support",
  "family_support_block",
  "how_it_works",
  "testimonials",
  "disclaimer",
  "booking_section",
  "final_cta",
  "contact_form",
];

export const ABOUT_PAGE_SECTIONS = [
  "about_hero",
  "about_sarah",
  "values",
  "why_started",
  "testimonials",
  "trust_strip",
  "final_cta",
  "booking_section",
];

export const PRICING_PAGE_SECTIONS = [
  "pricing_hero",
  "pricing_cards",
  "package_options",
  "testimonials",
  "pricing_note",
  "booking_section",
  "final_cta",
];

export const CONTACT_PAGE_SECTIONS = [
  "contact_hero",
  "booking_section",
  "contact_options_section",
  "contact_form",
  "contact_reassurance",
];
